"use client"

import { Bell } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BellIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BellIcon = component(Icon)({ as: Bell })
